import { useAppDispatch, useAppSelector } from '@hooks/redux';
import { authCounterpartyActionApi } from '@http/counterparties';
import { Button, Divider, Tag } from 'antd';
import { useTranslation } from 'react-i18next';

const CounterpartyInfo = ({ counterpartyInfo }: any) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const user = useAppSelector(state => state.appReducer.user);

  const isAuthenticator = () => counterpartyInfo.authenticator.find((item: any) => item.authenticator_id === user.id);

  const isAlreadyAuthed = () =>
    counterpartyInfo.authenticator.find((item: any) => item.authenticator_id === user.id && item.authed);

  return (
    <div>
      <div className='grid grid-cols-7 items-center py-5 max-sm:px-8 px-2 border-b lg:gap-5 max-sm:text-xs'>
        <div />
        <div className='max-sm:col-span-7 max-sm:leading-6 col-span-5 leading-8'>
          {counterpartyInfo?.counterparty_type === 'RESIDENT' ? (
            <div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Name')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.title}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Account')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.receiving_ac}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('TIN')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.tax_id}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('BIC')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.bank_code}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Phone number')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.phone_number}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Email')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.email}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Date of creation')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.created_at}</p>
              </div>
            </div>
          ) : (
            <div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Name')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.title}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Account')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.receiving_ac}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('TIN')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.tax_id}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Recipient bank name')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.receiver_bank_name}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Recipient bank swift')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.receiver_bank_swift}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('КПП')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.receiver_kpp}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Recipient country name')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.receiver_bank_country}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Recipient country')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.receiver_country}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Recipient city')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.receiver_city}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Recipient address')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.receiver_address}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Recipient city')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.receiver_city}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Phone number')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.phone_number}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Email')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.email}</p>
              </div>
              <div className='grid grid-cols-6'>
                <p className='col-span-2'>{t('Date of creation')}: </p>
                <p className='ml-3 font-semibold col-span-4'>{counterpartyInfo?.created_at}</p>
              </div>
            </div>
          )}
          {counterpartyInfo.authenticator.length > 0 ? (
            <div className='grid grid-cols-6'>
              <p className='col-span-2'>{t('Authorizers')}: </p>
              <div className='ml-3 col-span-4'>
                {counterpartyInfo.authenticator.map((item: any) => (
                  <div className='flex items-center '>
                    <p className='mr-3 font-semibold'>{item.authenticator_name}</p>
                    {item.authed === true ? <Tag color='success'>{t('Approved')}</Tag> : null}
                    {item.authed === false ? <Tag color='error'>{t('Rejected')}</Tag> : null}
                    {item.authed === null ? <Tag color='processing'>{t('Signing in')}</Tag> : null}
                  </div>
                ))}
              </div>
            </div>
          ) : null}

          {isAuthenticator() && !isAlreadyAuthed() ? (
            counterpartyInfo.status !== '' && counterpartyInfo.status !== 'APPROVED' ? (
              <div>
                <Divider />
                <div>
                  <Button
                    type='primary'
                    danger
                    className='mr-4'
                    onClick={() => {
                      dispatch(authCounterpartyActionApi({ counter_id: counterpartyInfo.id, action: 'DECLINE' }));
                    }}
                  >
                    {t('Reject')}
                  </Button>
                  <Button
                    type='primary'
                    onClick={() => {
                      dispatch(authCounterpartyActionApi({ counter_id: counterpartyInfo.id, action: 'APPROVE' }));
                    }}
                  >
                    {t('Confirm')}
                  </Button>
                </div>
              </div>
            ) : null
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CounterpartyInfo;
